export function Article({ children }) {
  return <article className="flex h-svh max-h-[100vh] flex-col bg-primary-x-light">{children}</article>;
}
